export const PRIVATE = 'PRIVATE';
export const PUBLIC = 'PUBLIC';
export const SENDABLE = 'SENDABLE';
